var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteFolder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 8.25C18.6665 6.85218 18.6665 5.90326 18.4476 5.35195C18.1559 4.61687 17.5961 4.03284 16.8918 3.72836C16.3633 3.5 15.6936 3.5 14.354 3.5C13.3683 3.5 12.3825 3.5 11.3968 3.5C11.2352 3.5 11.1544 3.5 11.0766 3.49559C10.4225 3.45855 9.8002 3.18957 9.3126 2.73317C9.25452 2.67884 9.1974 2.61923 9.08317 2.5C8.96891 2.38077 8.91178 2.32116 8.85375 2.26683C8.36616 1.81043 7.74383 1.54145 7.08978 1.50441C7.01193 1.5 6.93114 1.5 6.76955 1.5C6.51854 1.5 6.26752 1.5 6.0165 1.5C4.40635 1.5 3.60127 1.5 2.98628 1.82698C2.44531 2.1146 2.0055 2.57354 1.72986 3.13803C1.4165 3.77976 1.4165 4.61984 1.4165 6.3C1.4165 8.43333 1.4165 10.5667 1.4165 12.7C1.4165 14.3802 1.4165 15.2202 1.72986 15.862C2.0055 16.4265 2.44531 16.8854 2.98628 17.173C3.60127 17.5 4.40635 17.5 6.0165 17.5C7.35817 17.5 8.69984 17.5 10.0415 17.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57385 9.5C5.57385 9.5 3.04655 11.8649 2.6882 13.3829C2.32986 14.9009 2.37485 15.4553 2.6882 16.0309C2.96384 16.5372 3.40366 16.9488 3.94463 17.2067C4.55962 17.5 5.36469 17.5 6.97485 17.5C9.65818 17.5 12.3415 17.5 15.0248 17.5C16.635 17.5 16.8258 17.5 17.4409 17.2067C17.9818 16.9488 18.4216 16.5372 18.6972 16.0309C18.8592 15.7334 19.027 14.7957 19.5769 13.3829C20.0907 12.0627 20.9728 10.2814 21.5415 9.5H5.57385Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteFolder);
export default __webpack_public_path__ + "static/media/whiteFolder.30163401273efb822a03dfa5316b8b80.svg";
export { ForwardRef as ReactComponent };